module.exports = __webpack_public_path__ + "static/media/education.6a00d992.svg";